import { useQuery } from '@tanstack/react-query';

import BusinessReviewsService from '../../services/BusinessReviewsService';

export enum BUSINESS_REVIEW_QUERY_KEYS {
  GET_BUSINESS_REVIEWS = 'get-business-reviews',
}

const businessReviewsService = new BusinessReviewsService();

export const useGetBusinessReviewsQuery = () => {
  const { data: businessReviews } = useQuery({
    queryKey: [BUSINESS_REVIEW_QUERY_KEYS.GET_BUSINESS_REVIEWS],
    queryFn: () => businessReviewsService.getBusinessReviews(),
  });

  return {
    businessReviews,
  };
};
